const ConsentName = {
  AdStorage: 'rodo_ad_storage',
  AnalyticsStorage: 'rodo_analytics_storage',
  PersonalizationStorage: 'rodo_personalization_storage'
};

module.exports = { ConsentName };
